import { defaultTimeline } from "../data/defaults/timeline.types.defaults"
import { useAppSelector } from "./useRedux"

/**
 * Subscribed access to the GSAP master timeline and its duration.
 *
 * Split out of `useTimelineActions` on purpose: `updateMasterTimeline` puts a NEW GSAPTimeline
 * instance into the store on every rebuild — which happens at the end of every drag, resize or
 * style edit. `useTimelineActions` is instantiated in every TimelineRow, every TimeStamp and,
 * through `useObjectActions`, in every CanvasItem and AbstractContainer, so that subscription
 * re-rendered the entire canvas plus the entire timeline on each rebuild. Only the components
 * that actually render a duration should be subscribed; everything else needs the timeline
 * inside a handler and reads it on demand.
 */
export const useMasterTimeline = () => {
    const masterTimeline: GSAPTimeline | null = useAppSelector(
        (state) => state.masterTimeline.value
    )
    const minduration = useAppSelector((state) => state.timeline.value.minduration)

    const effectiveTimelineDuration = masterTimeline ? masterTimeline.duration() : 0
    const masterTimelineDuration = Math.max(
        effectiveTimelineDuration,
        minduration ? minduration : defaultTimeline.minduration
    )

    return { masterTimeline, masterTimelineDuration, effectiveTimelineDuration }
}
